"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { getYandexMetrikaId, isScriptario, publicAppEnv, siteLocale } from "@/lib/config";
import { sendScriptarioAnalyticsEvent } from "@/lib/scriptario-analytics";

declare global {
  interface Window {
    ym?: (...args: unknown[]) => void;
  }
}

let lastTrackedScriptarioPageViewKey = "";

export function TrackPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();

  useEffect(() => {
    const url = `${pathname}${search ? `?${search}` : ""}`;

    if (isScriptario) {
      const pageViewKey = `${publicAppEnv}:scriptario:${siteLocale}:${url}`;
      if (lastTrackedScriptarioPageViewKey === pageViewKey) return;

      const payload = {
        page_path: url,
        page_location: window.location.href,
        page_title: document.title,
        environment: publicAppEnv,
        site_id: "scriptario",
        locale: siteLocale,
      };
      if (sendScriptarioAnalyticsEvent("page_view", payload)) {
        lastTrackedScriptarioPageViewKey = pageViewKey;
      }
      return;
    }

    const metrikaId = getYandexMetrikaId();
    if (!metrikaId || typeof window === "undefined" || !window.ym) return;

    window.ym(metrikaId, "hit", url);
    console.debug("YM Page view tracked:", url);
  }, [pathname, search]);

  return null;
}
